import { createAsyncThunk } from '@reduxjs/toolkit';
import { _billingUrls, _priceUrls } from '@custom/Utils/constants/apiUrls';

interface EditPackagePayload {
  packageId: string;
  packageName: string;
  servicesIncluded: string[];
  packagePricing: string;
  hospitalId: string;
}

const editPackage = createAsyncThunk(
  'editPackage',
  async ({ packageId, ...payload }: EditPackagePayload) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const url = `${_billingUrls.edit}/${packageId}`;

      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Failed to update billing package');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

export default editPackage;
